define.alias("shared/utils/number-helpers/format-number-with-suffix", "settings/utils/number-helpers/format-number-with-suffix");